<div class="card padding-card t-align-l no-radius border">
    <form>
        <div class="card-body">
            <h5 class="card-title mb-4">
                Floor Plans
            </h5>

            <!-- Error/Success Messages -->
            <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show">
                {{ errorMessage }}
                <button type="button" class="close" (click)="errorMessage = ''">
                    <span>&times;</span>
                </button>
            </div>
            <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show">
                {{ successMessage }}
                <button type="button" class="close" (click)="successMessage = ''">
                    <span>&times;</span>
                </button>
            </div>

            <!-- File Upload Section -->
            <div class="form-group">
                <label for="floorPlanUpload" class="form-label">
                    <strong>Upload Floor Plan Images</strong>
                </label>
                <div class="custom-file">
                    <input type="file" class="custom-file-input" id="floorPlanUpload" multiple accept="image/*"
                        (change)="onFloorPlanImageSelected($event)"
                        [disabled]="isUploading" />
                    <label class="custom-file-label" for="floorPlanUpload">
                        Choose images...
                    </label>
                </div>
                <small class="form-text text-muted">
                    Supported formats: JPG, PNG, GIF. Max file size: {{ maxImageSize }}MB
                </small>
            </div>

            <!-- Floor Plans Grid Display -->
            <div class="row mt-4">
                <div class="col-md-12">
                    <h6>Floor Plans ({{ floorPlanImages.length }})</h6>
                </div>

                <div class="col-md-4 mb-4" *ngFor="let floorPlan of floorPlanImages; let i = index;">
                    <div class="card floor-plan-card" [class.selected]="selectedImageIndex === i">
                        <!-- Upload Progress -->
                        <div *ngIf="floorPlan.isUploading" class="progress">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" 
                                [style.width.%]="floorPlan.uploadProgress">
                                {{ floorPlan.uploadProgress | number:'1.0-0' }}%
                            </div>
                        </div>

                        <!-- Floor Plan Image Preview -->
                        <img [src]="floorPlan.url" class="card-img-top floor-plan-image" 
                            alt="{{ floorPlan.name }}" (click)="selectFloorPlan(i)" />

                        <!-- Floor Plan Details -->
                        <div class="card-body">
                            <h6 class="card-title">{{ floorPlan.name }}</h6>
                        </div>

                        <!-- Actions -->
                        <div class="card-footer d-flex justify-content-end">
                            <button type="button" class="btn btn-sm btn-danger" (click)="deleteFloorPlan(i)">
                                🗑 Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer Buttons -->
        <div class="card-footer">
            <div class="button-group">
                <button type="button" class="btn btn-primary btn-lg float-right mr-2" (click)="submit()">
                    Next
                </button>
                <button type="button" class="btn btn-secondary btn-lg float-right mr-2" (click)="back()">
                    Back
                </button>
            </div>
        </div>
    </form>
</div>

